<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">Segments</div>
        <div class="section-subTitle my-2">Manage All your Segments here.</div>
      </div>
      <div>
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <!-- v-if="cinema_manager_add_edit_disabled != 3" -->
        <b-button
          variant="default"
          :to="{ name: 'Add Segment' }"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-end mb-3">
      <!-- <FilterByStatusDropdown /> -->
    </div>

    <!-- <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
            >{{list.name}}</b-dropdown-item>
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active':''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active':''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>-->

    <!-- LIST VIEW DESIGNATION -->
    <!-- <div class="desg-list-container">
      <div class="desg-list-header">
        <div>Segments</div>
        <div>Type</div>
        <div class="pr-5">{{ $tc("status", 2) }}</div>
      </div>
      <ul class="desg-list">
        <li
          v-for="(segment, segmentLoopKey) in mapped_customer_segments"
          :key="segmentLoopKey"
        >
          <div>{{ segment.segment_name }}</div>
          <div>{{ segment.segment_type }}</div>

          <div class="d-flex align-items-center">
            <label class="ios-switch">
              <input
                v-model="segment.segment_is_active"
                value="Y"
                disabled
                type="checkbox"
                class="ios-checkbox"
              />
              <span class="switch-slider"></span>
            </label>
            <b-dropdown right variant="edit" class="ml-4">
              <b-dropdown-item
                :to="{
                  name: 'Edit Segment',
                  params: { segment_id: segment.segment_id }
                }"
              >
                <span class="edit-pen mr-1"></span>
                {{ $t("edit") }}
              </b-dropdown-item>
              <b-dropdown-item
                :to="{
                  name: 'View Segment',
                  params: { segment_id: segment.segment_id }
                }"
              >
                <span class="icon-eye mr-1"></span>
                {{ $t("view") }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </li>
      </ul>
    </div> -->
    <table class="list-view-table">
      <thead>
        <tr>
          <th>Segments</th>
          <th class="text-center">Type</th>
          <th class="text-right pr-5">{{ $tc("status", 2) }}</th>
        </tr>
      </thead>
      <tbody v-if="mapped_customer_segments.length>0">
        <tr
          v-for="(segment, segmentLoopKey) in mapped_customer_segments"
          :key="segmentLoopKey"
        >
          <td>{{ segment.segment_name }}</td>
          <td class="text-center">{{ segment.segment_type }}</td>

          <td class="text-right">
            <div class="d-flex align-items-center justify-content-end">
              <!-- <label class="ios-switch">
                <input
                  v-model="segment.segment_is_active"
                  value="Y"
                  disabled
                  type="checkbox"
                  class="ios-checkbox"
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="
                  segment.segment_is_active === 'Y'
                    ? 'active'
                    : segment.segment_is_active === 'N' && 'inactive'
                "
              />

              <b-dropdown right variant="edit" class="ml-3">
                <b-dropdown-item
                  :to="{
                    name: 'Edit Segment',
                    params: { segment_id: segment.segment_id }
                  }"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  :to="{
                    name: 'View Segment',
                    params: { segment_id: segment.segment_id }
                  }"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="3">
            <NoRecords/>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <!-- <b-pagination
      v-model="currentPage"
      total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>-->
  </div>
</template>
<script>
import MarketingAutomation from "@/services/MarketingAutomationService";
import moment from "moment";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      mapped_customer_segments: []
    };
  },
  mounted() {
    this.getSegments();
  },
  methods: {
    getSegments() {
      MarketingAutomation.GetSegments()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.mapped_customer_segments = data.Records;
            console.log(
              "this.mapped_customer_segments :",
              this.mapped_customer_segments
            );
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingAutomationContainer/Segments/Segments.vue